import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const usePartnerAdminNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTabFromUrl = () => {
    const path = location.pathname;
    if (path === '/partner-admin/users') return 'users';
    if (path === '/partner-admin/user-approvals') return 'user-approvals';
    if (path === '/partner-admin/subscriptions') return 'subscriptions';
    if (path === '/partner-admin/subscription-management') return 'subscription-management';
    if (path === '/partner-admin/order-management') return 'order-management';
    if (path === '/partner-admin/reports') return 'reports';
    if (path === '/partner-admin/partner-wallet') return 'partner-wallet';
    if (path === '/partner-admin/partner-wallet-ledger') return 'partner-wallet-ledger';
    if (path === '/partner-admin/settings') return 'settings';
    if (path === '/partner-admin/dashboard') return 'overview';
    if (path === '/partner-admin') return 'overview';
    return 'overview';
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());

  useEffect(() => {
    const tabFromUrl = getActiveTabFromUrl();
    if (tabFromUrl !== activeTab) setActiveTab(tabFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleTabChange = (tab) => {
    const routeMap = {
      'overview': '/partner-admin/dashboard',
      'users': '/partner-admin/users',
      'user-approvals': '/partner-admin/user-approvals',
      'subscriptions': '/partner-admin/subscriptions',
      'subscription-management': '/partner-admin/subscription-management',
      'order-management': '/partner-admin/order-management',
      'reports': '/partner-admin/reports',
      'partner-wallet': '/partner-admin/partner-wallet',
      'partner-wallet-ledger': '/partner-admin/partner-wallet-ledger',
      'settings': '/partner-admin/settings'
    };
    navigate(routeMap[tab] || '/partner-admin/dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('token');
    navigate('/login');
  };

  return { activeTab, handleTabChange, handleLogout };
};